import { RootState } from '@redux/store';

export const getRecordService = (state: RootState) => state.services.userRecords;
export const getIsLoadedUserRecord = (state: RootState) => state.services.isLoadedUserRecords;
export const getIsErrorUserRecord = (state: RootState) => state.services.isErrorUserRecords;
